import MainPageSectionBrands from "../components/MainPageSections/MainPageSectionBrands";

import { Box, Flex, Heading, List, ListItem, Text } from "@chakra-ui/react";

import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import MainPageDiscoverSection from "../components/MainPageSections/MainPageDiscoverSection";
import Newsletter from "../components/Newsletter/Newsletter";

const MainPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [brandsLoaded, setBrandsLoaded] = useState(false);
  const [, setAboutUsLoaded] = useState(false);
  const [formLoaded, setFormLoaded] = useState(false);
  const [newsLetterLoaded, setNewsLetterLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await import("../components/MainPageSections/MainPageSectionBrands");
      setBrandsLoaded(true);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await import("../components/MainPageSections/MainPageAboutUs");
      setAboutUsLoaded(true);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await import("../components/MainPageSections/MainPageForm");
      setFormLoaded(true);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      await import("../components/Newsletter/Newsletter");
      setNewsLetterLoaded(true);
    };
    fetchData();
  }, []);

  return (
    <Box>
      <Helmet>
        <title>Bullet Scout</title>
        <meta
          name="description"
          content="Bullet Scout, your premier destination for finding the right ammunition for your firearm needs. With our comprehensive search engine, you can explore a wide array of ammunition options, ensuring you always hit your mark."
        />
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-JH75YYT0PY"
        />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-JH75YYT0PY');
          `}
        </script>
      </Helmet>
      <MainPageDiscoverSection />
      {brandsLoaded && <MainPageSectionBrands />}
      {formLoaded && newsLetterLoaded && (
        <Flex
          flexDirection={{ base: "column", md: "row" }}
          maxW={{ base: "", md: "7xl" }}
          mx={"auto"}
          justifyContent={"center"}
          gap={8}
          mt={"50px"}
          mb={"60px"}
        >
          <Box
            position={"relative"}
            zIndex={2}
            maxW={"605px"}
            w={"100%"}
          >
            <Heading
              as={"h2"}
              fontSize={"3xl"}
              fontWeight={"600"}
              fontFamily={"mainFont"}
              mb={"18px"}
            >
              About Us
            </Heading>
            <Text
              fontSize={"md"}
              fontWeight={"400"}
              fontFamily={"mainFont"}
              mb={6}
            >
              Welcome to Bullet Scout, your premier destination for finding the
              right ammunition for your firearm needs. With our comprehensive
              search engine, you can explore a wide array of ammunition options,
              ensuring you always hit your mark.
            </Text>
            <Heading
              as={"h3"}
              fontSize={"xl"}
              fontWeight={"600"}
              fontFamily={"mainFont"}
              mb={4}
            >
              Why choose us?
            </Heading>
            <List listStyleType={""} pl={4}>
              <ListItem
                fontSize={"md"}
                fontFamily={"mainFont"}
                mb={"6px"}
              >
                <Text as={"b"} mr={2}>
                  Extensive Selection:
                </Text>{" "}
                Access a diverse range of ammunition types, calibers, and
                brands.
              </ListItem>
              <ListItem
                fontSize={"md"}
                fontFamily={"mainFont"}
                mb={"6px"}
              >
                <Text as={"b"} mr={2}>
                  User-Friendly Interface:
                </Text>
                Our intuitive search engine makes finding the perfect ammunition
                quick and effortless.
              </ListItem>
              <ListItem
                fontSize={"md"}
                fontFamily={"mainFont"}
              >
                <Text as={"b"} mr={2}>
                  Expert Guidance:
                </Text>
                Benefit from recommendations and insights to enhance your
                shooting experience.
              </ListItem>
            </List>
          </Box>
          <Newsletter isPopup={false} />
        </Flex>
      )}
    </Box>
  );
};

export default MainPage;
